/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiStatisticsAuthorsQueryResponse, GetApiStatisticsAuthorsQueryParams, GetApiStatisticsAuthors400, GetApiStatisticsAuthors401, GetApiStatisticsAuthors403, GetApiStatisticsAuthors500 } from "../../types/GetApiStatisticsAuthors.ts";
import { getApiStatisticsAuthorsQueryResponseSchema } from "../../zod/AdminStatisticsSchemas/getApiStatisticsAuthorsSchema.ts";

function getGetApiStatisticsAuthorsUrl() {
  const res = { method: 'GET', url: `/api/statistics/authors` as const }  
  return res
}

/**
 * @summary Получение статистики по авторам
 * {@link /api/statistics/authors}
 */
export async function getApiStatisticsAuthors({ params }: { params: GetApiStatisticsAuthorsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiStatisticsAuthorsQueryResponse, ResponseErrorConfig<GetApiStatisticsAuthors400 | GetApiStatisticsAuthors401 | GetApiStatisticsAuthors403 | GetApiStatisticsAuthors500>, unknown>({ method : "GET", url : getGetApiStatisticsAuthorsUrl().url.toString(), params, ... requestConfig })  
  return getApiStatisticsAuthorsQueryResponseSchema.parse(res.data)
}